<script>
import store from '@state/store'
import { debounce } from 'debounce'

export default {
  methods: {
    filterData(data) {
      const newData = data.map((item) => {
        const { id, text } = item
        return { id, name: text }
      })
      return JSON.stringify(newData)
    },
    searchUsers: debounce(async function searchUsers() {
      if (!this.userTag) {
        return
      }
      store
        .dispatch('adminUsers/searchAdminsOfGroup', {
          companyId: this.companyId,
          groupId: this.groupId,
          userTag: this.userTag,
        })
        .then((data) => {
          if (data instanceof Array && data.length) {
            data.slice(0, 15)
            const userDisplayTags = data.map((item) => {
              const { id, name } = item
              return { id, text: name }
            })
            this.userDisplayTags = userDisplayTags
          }
        })
    }, 500),
    addSearchAdmins() {
      if (!this.userTags.length) {
        return
      }
      const params = {
        allAdmins: this.filterData(this.userTags),
      }

      store
        .dispatch('adminUsers/addAdminsToGroup', {
          companyId: this.companyId,
          groupId: this.groupId,
          params,
        })
        .then((response) => {
          this.$emit('refresh-admins-table')
          this.userTag = ''
          this.userTags = []
          this.userDisplayTags = []
          alert('Aamins have been successfully invited!')
        })
        .catch((err) => alert(err.message || 'Something went wrong.'))
    },
  },
}
</script>
